import { render, staticRenderFns } from "./DealerScreen.vue?vue&type=template&id=4ca6687a&"
import script from "./DealerScreen.vue?vue&type=script&lang=js&"
export * from "./DealerScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports